import apiService from "../../api/api.service";
import {
  OrderReviewsSummaryResponse,
  OrderReviewsListResponse,
  OrderReviewCreateResponse,
  OrderReviewUpdateResponse,
  OrderReviewDeleteResponse,
  CreateOrderReviewPayload,
  UpdateOrderReviewPayload,
  OrderReviewDetailResponse,
} from "./orderReviews.types";

export const getOrderReviewsSummary = () => {
  return apiService.get<OrderReviewsSummaryResponse>(
    "/customers/order-reviews/summary",
  );
};

export const getOrderReviews = (status?: string) => {
  const params = status ? { status } : undefined;
  return apiService.get<OrderReviewsListResponse>("/customers/order-reviews", {
    params,
  });
};

export const createOrderReview = (payload: CreateOrderReviewPayload) => {
  const formData = new FormData();

  formData.append("order_id", payload.order_id.toString());
  formData.append("seller_rating", payload.seller_rating.toString());
  formData.append("cargo_rating", payload.cargo_rating.toString());
  formData.append("comment", payload.comment);

  if (payload.images && payload.images.length > 0) {
    payload.images.forEach((image, index) => {
      formData.append(`images[${index}]`, image);
    });
  }
  if (payload.agreements && payload.agreements.length > 0) {
    payload.agreements.forEach((agreementId, index) => {
      formData.append(`agreements[${index}]`, agreementId.toString());
    });
  }

  return apiService.post<OrderReviewCreateResponse>(
    "/customers/order-reviews",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const editOrderReview = (payload: UpdateOrderReviewPayload) => {
  const formData = new FormData();

  formData.append("order_id", payload.order_id.toString());
  formData.append("seller_rating", payload.seller_rating.toString());
  formData.append("cargo_rating", payload.cargo_rating.toString());
  formData.append("comment", payload.comment);

  if (payload.images && payload.images.length > 0) {
    payload.images.forEach((image, index) => {
      formData.append(`images[${index}]`, image);
    });
  }

  return apiService.post<OrderReviewUpdateResponse>(
    `/customers/order-reviews/${payload.id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const removeOrderReview = (id: number) => {
  return apiService.delete<OrderReviewDeleteResponse>(
    `/customers/order-reviews/${id}`,
  );
};

export const getOrderReviewById = (id: number) => {
  return apiService.get<OrderReviewDetailResponse>(
    `/customers/order-reviews/${id}`,
  );
};

export const forceRemoveOrderReview = (id: number) => {
  return apiService.delete<OrderReviewDeleteResponse>(
    `/customers/order-reviews/${id}/force`,
  );
};
